import type {CoinMap} from "@/lib/internal-data/coinMap";
import {coinMap} from "@/lib/internal-data/coinMap";
import {converterCurrencies} from "@consts";

export const getCoinInfoBySlug = (slug:string):CoinMap[0] => {

    const currency = converterCurrencies.find((currency) => currency.name === slug.toLowerCase());
    if(currency) {
        return {
            name: currency.long_name,
            symbol: currency.name,
            slug: currency.name,
            img_url: currency.icon,
        }
    }

    const found = coinMap.find((coin: CoinMap[0]) => slug === coin?.slug);
    return found ?? {
        name: slug,
        symbol: slug,
        slug: slug,
        img_url: '',
    }
}

export const getCoinInfoBySymbol = (symbol:string):CoinMap[0] => {

    const currency = converterCurrencies.find((currency) => currency.name === symbol.toLowerCase());

    if(currency) {
        return {
            name: currency.long_name,
            symbol: currency.name,
            slug: currency.name,
            img_url: currency.icon,
        }
    }

    const found = coinMap.find((coin: CoinMap[0]) => symbol.toUpperCase() === coin?.symbol?.toUpperCase());
    return found ?? {
        name: symbol.toUpperCase(),
        symbol: symbol.toUpperCase(),
        slug: symbol.toUpperCase(),
        img_url: '',
    }
}